export const adoptableCats = [
  {
    id: 1,
    name: 'Whiskers',
    age: '2 years',
    gender: 'Male',
    breed: 'Domestic Shorthair',
    color: 'Orange Tabby',
    personality: ['Playful', 'Affectionate', 'Good with kids'],
    shelter: 'Happy Paws Rescue',
    shelterCity: 'Portland, OR',
    distance: '2.3 mi',
    image: 'https://public.readdy.ai/ai/img_res/74e27493d07dcba28d4895fb52f30587.jpg',
    tag: 'Friendly',
    tagColor: 'bg-emerald-100 text-emerald-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 2,
    name: 'Luna',
    age: '8 months',
    gender: 'Female',
    breed: 'Siamese Mix',
    color: 'Seal Point',
    personality: ['Curious', 'Vocal', 'Cuddly'],
    shelter: 'Second Chance Cats',
    shelterCity: 'Portland, OR',
    distance: '3.1 mi',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20young%20siamese%20mix%20kitten%20with%20blue%20eyes%20and%20seal%20point%20coloring%20sitting%20elegantly%20on%20soft%20cream%20cushion%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20soft%20lighting%2C%20adorable%20adoption%20portrait&width=600&height=600&seq=adopt2&orientation=squarish',
    tag: 'Kitten',
    tagColor: 'bg-amber-100 text-amber-700',
    neutered: true,
    vaccinated: true,
    microchipped: false,
  },
  {
    id: 3,
    name: 'Shadow',
    age: '4 years',
    gender: 'Male',
    breed: 'Domestic Longhair',
    color: 'Black',
    personality: ['Gentle', 'Calm', 'Independent'],
    shelter: 'Furry Friends Foundation',
    shelterCity: 'Beaverton, OR',
    distance: '5.7 mi',
    image: 'https://readdy.ai/api/search-image?query=majestic%20fluffy%20black%20cat%20with%20golden%20yellow%20eyes%20lounging%20on%20soft%20gray%20blanket%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20dramatic%20soft%20lighting%20highlighting%20fur%20texture%2C%20elegant%20adoption%20portrait&width=600&height=600&seq=adopt3&orientation=squarish',
    tag: 'Calm',
    tagColor: 'bg-sky-100 text-sky-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 4,
    name: 'Mochi',
    age: '1 year',
    gender: 'Female',
    breed: 'Scottish Fold Mix',
    color: 'Gray & White',
    personality: ['Sweet', 'Gentle', 'Good with pets'],
    shelter: 'Whisker Haven',
    shelterCity: 'Lake Oswego, OR',
    distance: '7.2 mi',
    image: 'https://readdy.ai/api/search-image?query=cute%20gray%20and%20white%20scottish%20fold%20mix%20cat%20with%20folded%20ears%20and%20round%20face%20sitting%20on%20soft%20pink%20blanket%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20gentle%20lighting%2C%20sweet%20expression%20adoption%20portrait&width=600&height=600&seq=adopt4&orientation=squarish',
    tag: 'Good with pets',
    tagColor: 'bg-violet-100 text-violet-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 5,
    name: 'Ginger',
    age: '6 years',
    gender: 'Female',
    breed: 'Maine Coon Mix',
    color: 'Ginger Tabby',
    personality: ['Regal', 'Loving', 'Lap cat'],
    shelter: 'Happy Paws Rescue',
    shelterCity: 'Portland, OR',
    distance: '2.3 mi',
    image: 'https://readdy.ai/api/search-image?query=gorgeous%20fluffy%20ginger%20maine%20coon%20mix%20cat%20with%20tufted%20ears%20and%20bushy%20tail%20sitting%20proudly%20on%20cream%20colored%20surface%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20golden%20lighting%2C%20regal%20adoption%20portrait&width=600&height=600&seq=adopt5&orientation=squarish',
    tag: 'Lap Cat',
    tagColor: 'bg-rose-100 text-rose-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 6,
    name: 'Beans',
    age: '3 months',
    gender: 'Male',
    breed: 'Tuxedo',
    color: 'Black & White',
    personality: ['Energetic', 'Playful', 'Mischievous'],
    shelter: 'Kitten Rescue League',
    shelterCity: 'Tigard, OR',
    distance: '8.4 mi',
    image: 'https://readdy.ai/api/search-image?query=tiny%20adorable%20black%20and%20white%20tuxedo%20kitten%20with%20bright%20eyes%20playing%20with%20small%20toy%20on%20soft%20white%20surface%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20bright%20cheerful%20lighting%2C%20playful%20kitten%20adoption%20portrait&width=600&height=600&seq=adopt6&orientation=squarish',
    tag: 'Kitten',
    tagColor: 'bg-amber-100 text-amber-700',
    neutered: false,
    vaccinated: true,
    microchipped: false,
  },
  {
    id: 7,
    name: 'Cleo',
    age: '9 years',
    gender: 'Female',
    breed: 'Calico',
    color: 'Calico',
    personality: ['Wise', 'Affectionate', 'Quiet'],
    shelter: 'Second Chance Cats',
    shelterCity: 'Portland, OR',
    distance: '3.1 mi',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20senior%20calico%20cat%20with%20patches%20of%20orange%20white%20and%20black%20fur%20resting%20peacefully%20on%20soft%20blue%20blanket%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20soft%20lighting%2C%20gentle%20wise%20expression%20adoption%20portrait&width=600&height=600&seq=adopt7&orientation=squarish',
    tag: 'Senior',
    tagColor: 'bg-teal-100 text-teal-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 8,
    name: 'Ziggy',
    age: '1.5 years',
    gender: 'Male',
    breed: 'Bengal Mix',
    color: 'Spotted Brown',
    personality: ['Adventurous', 'Athletic', 'Curious'],
    shelter: 'Furry Friends Foundation',
    shelterCity: 'Beaverton, OR',
    distance: '5.7 mi',
    image: 'https://readdy.ai/api/search-image?query=striking%20spotted%20bengal%20mix%20cat%20with%20vivid%20markings%20and%20alert%20expression%20sitting%20on%20natural%20wood%20surface%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20bright%20natural%20lighting%2C%20athletic%20build%20adoption%20portrait&width=600&height=600&seq=adopt8&orientation=squarish',
    tag: 'Active',
    tagColor: 'bg-orange-100 text-orange-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
  {
    id: 9,
    name: 'Mittens',
    age: '5 years',
    gender: 'Female',
    breed: 'Domestic Shorthair',
    color: 'Gray Tabby',
    personality: ['Shy', 'Sweet', 'Gentle'],
    shelter: 'Whisker Haven',
    shelterCity: 'Lake Oswego, OR',
    distance: '7.2 mi',
    image: 'https://readdy.ai/api/search-image?query=sweet%20gray%20tabby%20cat%20with%20soft%20green%20eyes%20peeking%20out%20from%20cozy%20knitted%20blanket%2C%20clean%20simple%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20ambient%20lighting%2C%20shy%20but%20sweet%20expression%20adoption%20portrait&width=600&height=600&seq=adopt9&orientation=squarish',
    tag: 'Shy but sweet',
    tagColor: 'bg-pink-100 text-pink-700',
    neutered: true,
    vaccinated: true,
    microchipped: true,
  },
];

export const shelters = [
  {
    id: 1,
    name: 'Happy Paws Rescue',
    city: 'Portland, OR',
    address: '1234 SE Hawthorne Blvd, Portland, OR 97214',
    phone: '(503) 555-0142',
    catsAvailable: 23,
    image: 'https://readdy.ai/api/search-image?query=warm%20inviting%20animal%20shelter%20storefront%20with%20large%20windows%20showing%20cats%20inside%2C%20friendly%20welcoming%20entrance%20with%20potted%20plants%2C%20clean%20modern%20building%20exterior%2C%20soft%20warm%20lighting%2C%20professional%20architectural%20photography&width=600&height=400&seq=shelter1&orientation=landscape',
  },
  {
    id: 2,
    name: 'Second Chance Cats',
    city: 'Portland, OR',
    address: '567 NW 23rd Ave, Portland, OR 97210',
    phone: '(503) 555-0198',
    catsAvailable: 18,
    image: 'https://readdy.ai/api/search-image?query=cozy%20cat%20rescue%20center%20interior%20with%20cats%20lounging%20on%20cat%20trees%20and%20shelves%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20space%20with%20large%20windows%2C%20welcoming%20atmosphere%2C%20professional%20interior%20photography&width=600&height=400&seq=shelter2&orientation=landscape',
  },
  {
    id: 3,
    name: 'Furry Friends Foundation',
    city: 'Beaverton, OR',
    address: '890 SW Cedar Hills Blvd, Beaverton, OR 97005',
    phone: '(503) 555-0267',
    catsAvailable: 31,
    image: 'https://readdy.ai/api/search-image?query=bright%20cheerful%20animal%20adoption%20center%20with%20colorful%20cat%20play%20areas%20and%20climbing%20structures%2C%20clean%20modern%20facility%2C%20natural%20light%20streaming%20through%20windows%2C%20professional%20photography&width=600&height=400&seq=shelter3&orientation=landscape',
  },
  {
    id: 4,
    name: 'Whisker Haven',
    city: 'Lake Oswego, OR',
    address: '345 A Ave, Lake Oswego, OR 97034',
    phone: '(503) 555-0321',
    catsAvailable: 14,
    image: 'https://readdy.ai/api/search-image?query=charming%20small%20town%20cat%20shelter%20with%20cottage%20style%20exterior%2C%20flower%20boxes%20in%20windows%2C%20welcoming%20front%20porch%2C%20warm%20sunset%20lighting%2C%20quaint%20and%20inviting%20atmosphere%2C%20professional%20photography&width=600&height=400&seq=shelter4&orientation=landscape',
  },
  {
    id: 5,
    name: 'Kitten Rescue League',
    city: 'Tigard, OR',
    address: '678 Pacific Hwy, Tigard, OR 97223',
    phone: '(503) 555-0455',
    catsAvailable: 27,
    image: 'https://readdy.ai/api/search-image?query=modern%20animal%20rescue%20facility%20with%20glass%20front%20showing%20kittens%20playing%20inside%2C%20clean%20contemporary%20design%2C%20bright%20welcoming%20entrance%2C%20professional%20architectural%20photography&width=600&height=400&seq=shelter5&orientation=landscape',
  },
];

export const adoptionSteps = [
  {
    icon: 'ri-search-line',
    title: 'Browse Cats',
    description: 'Search adoptable cats near you by location, age, breed, or personality.',
  },
  {
    icon: 'ri-heart-line',
    title: 'Find Your Match',
    description: 'Read profiles, view photos, and find the cat that steals your heart.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Submit Inquiry',
    description: 'Fill out a quick adoption inquiry form to connect with the shelter.',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Welcome Home',
    description: 'Meet your new best friend and bring them to their forever home!',
  },
];

export const successStories = [
  {
    name: 'Oliver',
    adopter: 'Sarah M.',
    story: 'Oliver was so shy at the shelter, but now he greets me at the door every day. He\'s the best decision I ever made!',
    image: 'https://readdy.ai/api/search-image?query=happy%20orange%20cat%20relaxing%20on%20cozy%20couch%20in%20warm%20living%20room%20with%20sunlight%20streaming%20through%20window%2C%20content%20and%20comfortable%20in%20forever%20home%2C%20warm%20lifestyle%20photography&width=400&height=400&seq=success1&orientation=squarish',
    shelter: 'Happy Paws Rescue',
  },
  {
    name: 'Pepper',
    adopter: 'James & Lily K.',
    story: 'We adopted Pepper as a senior cat and she has brought so much joy to our family. She purrs non-stop!',
    image: 'https://readdy.ai/api/search-image?query=content%20black%20and%20white%20cat%20being%20gently%20petted%20by%20human%20hand%20on%20soft%20bed%2C%20peaceful%20happy%20expression%2C%20warm%20cozy%20home%20environment%2C%20lifestyle%20photography&width=400&height=400&seq=success2&orientation=squarish',
    shelter: 'Second Chance Cats',
  },
  {
    name: 'Noodle',
    adopter: 'Emily R.',
    story: 'Noodle went from a scared kitten to the most confident, playful cat. Adoption changed both our lives.',
    image: 'https://readdy.ai/api/search-image?query=playful%20tabby%20cat%20stretching%20on%20cat%20tree%20near%20sunny%20window%20in%20modern%20apartment%2C%20happy%20and%20energetic%2C%20bright%20cheerful%20home%20setting%2C%20lifestyle%20photography&width=400&height=400&seq=success3&orientation=squarish',
    shelter: 'Kitten Rescue League',
  },
];
